module.exports = __webpack_public_path__ + "img/logn.eb10c648.png";